import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Saved reusable certificate templates (optionally filtered by type).
const GetCertificateTemplates = async ({ payload } = { payload: {} }) => {
  const formData = new FormData();
  if (payload && payload.session) formData.append("session", payload.session);
  if (payload && payload.type) formData.append("type", payload.type);

  const res = await axios.post(ENDPOINT + "admin-get-certificate-templates.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default GetCertificateTemplates;
